/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Sitesettings_Tab_Checkout1Inputs */

const vi_sitesettings_tab_checkout1 = /** @type {(inputs: Sitesettings_Tab_Checkout1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Thanh toán & hỗ trợ đơn`)
};

/**

* @param {Sitesettings_Tab_Checkout1Inputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
const sitesettings_tab_checkout1 = /** @type {((inputs?: Sitesettings_Tab_Checkout1Inputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sitesettings_Tab_Checkout1Inputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_sitesettings_tab_checkout1(inputs)
});
export { sitesettings_tab_checkout1 as "siteSettings_tab_checkout" }